import request from '@/lib/request';
import { formatDataSourceHandle } from '@/lib/utils';
import { handleLog } from './logger';

// 新建标注
export function createCaseLabelRule(id, params) {
  return request.post('/nlp/case/add/label/relation/data', {
    id,
    body: params
  });
}

export function updCaseLabelRule(id, params) {
  return request.post('/nlp/case/update/label/relation/data', { id, body: params });
}

export function delCaseLabelRule(id) {
  return request.post('/nlp/case/update/label/relation/data', {
    id,
    body: { is_delete: 1 }
  });
}

export function hideCaseLabelRule(id, params) {
  return request.post('/nlp/case/hide/label/relation/data', { id, body: params });
}

export async function getTagStatistics(params) {
  const data = await request.post(
    '/v4/coursewares/count',
    formatDataSourceHandle({ ...params }, { includeCleanerFilter: true })
  );
  const result = {};
  data.forEach(item => {
    result[item.labelId] = item;
  });
  return result;
}

export function getKeywordByField(params) {
  return request.post('/nlp/case/tags/default', formatDataSourceHandle({ ...params }, { includeCleanerFilter: true }));
}

export async function getFieldDictVal({ labelId, keyword, courseId, size = 20, recommendWord, recommendWordType }) {
  const params = { id: labelId, keyword, page: 0, size, coursewareId: courseId };
  if (recommendWord) {
    params.recommendWord = recommendWord;
  }
  if (recommendWordType) {
    params.recommendWord_type = recommendWordType;
  }
  const { data } = await request.post('/nlp/label/dict/page', params);
  if (data.dict_classify_value) {
    data.dict_classify_value = data.dict_classify_value
      .filter(item => !!item.labelName)
      .map(item => {
        return { children: '', ...item };
      });
    data.dict_value = data.dict_classify_value.map(item => item.labelName);
  } else {
    data.dict_classify_value = (data.dict_value || [])
      .filter(text => !!text)
      .map(text => {
        return { labelName: text, children: '' };
      });
  }
  return { data };
}

export function getFieldsDictVal(ids) {
  return request.post('/nlp/label/dict/pages', { ids, field: ['dictClassifyValue'] });
}

export function getDefaultEntitie(params) {
  return request.post('/nlp/case/relation/extract', params);
}

export function addTagOfCase(id, params) {
  return request.post(`/nlp/case/label/operation/add/${id}`, params);
}

export function delTagOfCase(coursewareId, params) {
  return request.post(`/nlp/case/label/operation/delete/${coursewareId}`, params);
}

export function delTagRelationOfCase(ids) {
  return request.post('/nlp/case/relation/delete', { ids });
}

export function updTagOfCase(coursewareId, params) {
  return request.post(`/nlp/case/label/operation/update/${coursewareId}`, params);
}

export function moveRelationTagOfCase(params) {
  return request.post('/nlp/case/relation/modify', params);
}

function fetchAutoTagParams({ courseId, courseTitle, dataSource, fieldDetail, runType }) {
  const fieldTypeEnum = { text: 1, date: 2, num: 3 };
  const params = {
    course_id: courseId,
    course_name: courseTitle,
    distField: fieldDetail._id,
    distFieldKey: fieldDetail.field_name,
    parentId: fieldDetail.parentId,
    field_type: fieldDetail.type,
    fieldType: fieldTypeEnum[fieldDetail.type],
    run_type: runType,
    distFieldName: fieldDetail.title,
    pattern: fieldDetail.word,
    exclude_word: fieldDetail.exclude_word,
    exclude_sentence: fieldDetail.exclude_sentence,
    full_path: fieldDetail.full_path,
    fields: (fieldDetail.paragraphArr || []).length > 0 ? fieldDetail.paragraphArr : ['para_content'],
    body: formatDataSourceHandle(JSON.parse(dataSource), { includeCleanerFilter: true })
  };
  if (fieldDetail.type === 'num') {
    params.calculate = fieldDetail.calculate;
  }
  return params;
}

export function autuAddTag({ courseId, courseTitle, dataSource, fieldDetailArr, runType = '追加' }) {
  if (fieldDetailArr.length === 1) {
    handleLog({ operateName: '自动标注', apiUrl: '/nlp/case/label/extract' });
    const params = fetchAutoTagParams({ courseId, courseTitle, dataSource, fieldDetail: fieldDetailArr[0], runType });
    return request.post('/nlp/case/label/extract', params);
  } else {
    handleLog({ operateName: '自动批量标注', apiUrl: '/nlp/case/label/extract' });
    const params = fieldDetailArr.map(fieldDetail => {
      return fetchAutoTagParams({ courseId, courseTitle, dataSource, fieldDetail, runType });
    });
    return request.post('/nlp/case/label/extract/batch', params);
  }
}

export function cancelTagTask(id) {
  return request.post(`/nlp/runlabel/del/task/${id}`, {});
}

export async function getTaskQueueInfo(courseId, fieldIds) {
  const result = await request.post('/nlp/runlabel/task', { course_id: courseId, field_name: fieldIds });
  const data = [];
  const recommendTaskArr = {};
  result.data.forEach(item => {
    if (item._source.calculator_type === 5) {
      recommendTaskArr[item._source.field_name] = item;
    } else {
      data.push(item);
    }
  });
  return { ...result, data, recommendTaskArr };
}

export function codeTest(code, name) {
  return request.post('/nlp/case/test/model/coding', { calculator: code, name });
}

export function codeRun(params) {
  return request.post('/nlp/case/model/coding', params);
}

export function fieldReset(params) {
  return request.post('/nlp/case/label/restore', params);
}

export function refreshRecommend(fieldName) {
  return request.post(`/nlp/case/recommend/label/${fieldName}`, {});
}
